import React, { useState } from "react";

// Prefer AI-generated 3D image; fall back to curated stock if generation missing.
export default function ThreeDImage({ src, alt = "", className = "", ...rest }) {
  const [current, setCurrent] = useState(src.primary);
  return (
    <img
      src={current}
      alt={alt}
      loading="lazy"
      onError={() => {
        if (current !== src.fallback) setCurrent(src.fallback);
      }}
      className={className}
      {...rest}
    />
  );
}
